import { Component, Vue } from 'vue-property-decorator';
import { settings } from '@/settings';
import { version } from 'moment';

@Component

export default class FooterBar extends Vue {

  private get Version () {

  return `v. ${settings.version}`;
  }
}
